import { apiUrl } from "../../config/api";

export function sessionHeaders() {
  let session = {};
  try { session = JSON.parse(localStorage.getItem("sessionData") || "{}"); } catch (_) { /* expired storage */ }
  return { Authorization: session.sessionKey || "", Username: session.username || "" };
}

export function newOperation() {
  return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

// A lost response must replay the original operation, including after a page reload.
// Keep the key until a successful response is received. Validation failures and
// network uncertainty retain it; a completed operation can be followed by a new one.
const pendingKeys = new Map();
async function requestIdentity(value) {
  if (window.crypto?.subtle && typeof TextEncoder !== "undefined") {
    const bytes = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(value));
    return Array.from(new Uint8Array(bytes), (byte) => byte.toString(16).padStart(2, "0")).join("");
  }
  // Older non-secure browser contexts lack WebCrypto. This fingerprint is only
  // a local cache key; the server independently verifies the exact payload hash.
  const hashes = [2166136261, 2246822519, 3266489917, 668265263];
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    for (let part = 0; part < hashes.length; part += 1) hashes[part] = Math.imul(hashes[part] ^ code, 16777619 + part * 2) >>> 0;
  }
  return `${value.length.toString(16)}-${hashes.map((part) => part.toString(16).padStart(8, "0")).join("")}`;
}
export async function costRequest(path, { method = "GET", body, scope = "default", binary = false } = {}) {
  const headers = sessionHeaders();
  let identity;
  if (body !== undefined) headers["Content-Type"] = "application/json";
  if (method !== "GET") {
    identity = await requestIdentity(JSON.stringify([headers.Username, scope, method, path, body]));
    let key = pendingKeys.get(identity);
    try { key = key || sessionStorage.getItem(`ovm-cost:${identity}`); } catch (_) { /* storage unavailable */ }
    if (!key) key = newOperation();
    pendingKeys.set(identity, key);
    try { sessionStorage.setItem(`ovm-cost:${identity}`, key); } catch (_) { /* use in-memory key */ }
    headers["Idempotency-Key"] = key;
  }
  const response = await fetch(apiUrl(`/cost-control${path}`), {
    method, headers, ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (binary && response.ok) return response.blob();
  let data;
  try { data = await response.json(); } catch (_) { throw new Error("No se pudo leer la respuesta de Control de costos. Reintenta la misma operación."); }
  if (!response.ok || data.success === false) {
    const error = new Error(data.message || "No se pudo completar la operación.");
    error.status = response.status;
    throw error;
  }
  if (identity) {
    pendingKeys.delete(identity);
    try { sessionStorage.removeItem(`ovm-cost:${identity}`); } catch (_) { /* storage unavailable */ }
  }
  return data;
}

export async function downloadCostFile(path, filename) {
  const blob = await costRequest(path, { binary: true });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
